import { Box, Heading, VStack } from '@hover/blueprint';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { useIsMobileSize } from 'src/modules/renderings/hooks';
import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type Props = {
  onTryClick: () => void;
};

const BottomSection: React.FC<Props> = ({ onTryClick }) => {
  const isMobile = useIsMobileSize();
  const t = useTranslate(TranslationNamespace.DESIGNER_LANDING_PAGE);
  const { trackingData } = useHomeownerAppContext();
  return (
    <VStack
      alignItems={{ base: 'flex-start', tablet: 'center' }}
      pb={{ base: 900, tablet: 1200 }}
      pt={{ base: 800, tablet: 900 }}
      px={{ base: 500, tablet: undefined }}
    >
      <Box pb={{ base: 500, tablet: 600 }}>
        <Heading
          alignSelf="center"
          marginBottom="0px !important"
          size={{ base: 'xl', tablet: 'xxl' }}
          textAlign={{ base: 'left', tablet: 'center' }}
          width={{ base: '100%', tablet: 850 }}
        >
          {t('readyToSeeYourHome')}
        </Heading>
      </Box>
      <Button
        marginTop="0px !important"
        onClick={onTryClick}
        optionalTrackingProperties={{
          ...trackingData,
          primary_cta: true,
          feature: 'homeowner-web-app',
          page_or_screen_name: 'homeowner-app-home',
          track_id: 'designer-lp-bottom-cta',
          button_location: 'Bottom of page CTA',
        }}
        size="large"
        width={{ base: '100%', tablet: 'auto' }}
      >
        {isMobile ? t('getStarted') : t('tryItWithYourPlace')}
      </Button>
    </VStack>
  );
};

export { BottomSection };
